<template>
    <ion-item lines="none">
        <ion-label>{{ label }}</ion-label>
        <ion-checkbox :checked="checked" @ionChange="handleChange"> </ion-checkbox>
    </ion-item>
</template>

<script>
export default {
    name: 'Checkbox',
    props: ['label', 'checked', 'optionId'],
    methods: {
        handleChange: function(e) {
            this.$emit('onChange', {
                checked: e.detail.checked,
                optionId: this.optionId
            })
        }
    }
}
</script>

<style lang="scss" scoped>
ion-label {
    color: #aaaaaa !important;
}

@media (min-width: 768px) {
    ion-label {
        font-size: 110% !important;
    }
}

@media (min-width: 1200px) {
    ion-item {
        --background: #f5f5f5;
    }
}
</style>
